(function() {
  'use strict';

  angular.module('app').factory('ux', function(toaster) {
    return {
      reportSuccess: function(result, defaultMessage) {
        var msg = defaultMessage;

        if (result && typeof result === 'string') {
          msg = result;
        } else if (result && result.Message) {
          msg = result.Message;
        }

        toaster.pop({
          type: 'success',
          title: 'Success!',
          body: msg,
          timeout: 5000
        });
      },

      reportError: function(response, defaultMessage) {
        var msg = defaultMessage || 'Please contact your System Administrator.';

        var error = response.data ? response.data : response;

        if (error && typeof error === 'string') {
          msg = error;
        } else if (error && error.Message) {
          msg = error.Message;
        }

        toaster.pop({
          type: 'error',
          title: 'Error!',
          body: msg,
          timeout: 5000
        });

        if (error && error.Errors) {
          angular.forEach(error.Errors, function(validationMessage) {
            toaster.pop({
              type: 'warning',
              title: 'Entry invalid',
              body: validationMessage,
              timeout: 5000
            });
          });
        }
      }
    };
  });
})();
